module.exports = __webpack_public_path__ + "static/media/riven-icon.e52e221f.png";